import { render, staticRenderFns } from "./EipFont.vue?vue&type=template&id=47996e1c&scoped=true&"
import script from "./EipFont.vue?vue&type=script&lang=js&"
export * from "./EipFont.vue?vue&type=script&lang=js&"
import style0 from "./EipFont.vue?vue&type=style&index=0&id=47996e1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47996e1c",
  null
  
)

export default component.exports